module.exports = __webpack_public_path__ + "static/media/restore-k-20.8cf0604e.png";